/* eslint-disable @typescript-eslint/no-explicit-any */

import { ResizeBox } from "@/components/shared/resize-box";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { EyeIcon, PencilIcon, Trash2Icon } from "lucide-react";
import { ReactTableCell } from "../react-table-cell/react-table-cell";
import { ReactTableHeader } from "@/components/shared/react-table-header";
import { useUserInfo } from "@/global-data/use-user-info";
import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { CustomReactTableHeader } from "@/components/shared/custom-react-table-header";
export const ReactTable = ({
  tableHeader,
  onResize,
  table,
  // permission,
  onAction,
  filter,
  setFilter,
  listData,
  filterRequest,
  roleList,
}: any) => {
  const { activePermission } = useUserInfo();
  return (
    <Table style={{ borderCollapse: "collapse", width: "100%" }}>
      <TableHeader>
        <TableRow>
          <TableHead className="hidden">
            <input type="checkbox" />
          </TableHead>
          {tableHeader?.map((header: any, index: number) => (
            <TableHead
              key={index}
              style={{
                width: header.width,
                minWidth: header.minWidth,
                maxWidth: header.maxWidth,
              }}
              className={cn({ "pl-5": index === 0 })}
            >
              <ResizeBox
                width={header.width}
                onResize={(props: any) =>
                  onResize({ size: props, key: header.accessorKey })
                }
              >
                <SwitchRenderer
                  type={header.header}
                  components={{
                    "Role id": (
                      <CustomReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={roleList}
                        setFilter={setFilter}
                        filter={filter}
                        bindLabel="role_name"
                        bindValue="role_id"
                        filterRequest={filterRequest}
                      >
                        <span>Role</span>
                      </CustomReactTableHeader>
                    ),
                    default: (
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                      >
                        <span>{header.header}</span>
                      </ReactTableHeader>
                    ),
                  }}
                />
              </ResizeBox>

              {/* <ResizeBox
                width={header.width}
                onResize={(props: any) =>
                  onResize({ size: props, key: header.accessorKey })
                }
              >
                <ReactTableHeader
                  label={header.header}
                  key={header.accessorKey}
                  header={header.accessorKey}
                  table={listData}
                  setFilter={setFilter}
                  filter={filter}
                  filterRequest={filterRequest}
                >
                  {header.header}
                </ReactTableHeader>
              </ResizeBox> */}
            </TableHead>
          ))}
          <TableHead className="text-center  sticky right-0 z-[2] pr-0">
            <div className="flex justify-end">
              <div className="w-[66px] md:w-[135px] text-left pl-[8px]">
                Actions
              </div>
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {table.map((row: any, rowIndex: number) => (
          <TableRow key={row.id + rowIndex}>
            <TableCell className="w-[30px] hidden">
              <input type="checkbox" />
            </TableCell>
            {row.data.map((cell: any, index: number) => (
              <TableCell
                key={cell.key + index}
                width={cell.width}
                style={{ width: cell.width }}
                className={cn({ "pl-3": index === 0 })}
              >
                <ReactTableCell
                  header={cell.key}
                  value={cell.value}
                  roleList={roleList}
                />
              </TableCell>
            ))}
            <TableCell
              className="text-right sticky right-0 pr-0"
              nestedClassName="pr-0"
            >
              <div className="flex items-center justify-end z-[2] bg-white">
                <div className="flex items-center w-[66px] md:w-[135px]">
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button
                          variant={"ghost"}
                          size={"icon"}
                          className="text-primary hidden"
                          onClick={() =>
                            onAction({ data: row.originData, action: "view" })
                          }
                        >
                          <EyeIcon />
                        </Button>
                      </TooltipTrigger>

                      <TooltipContent>
                        <p>View</p>
                        <TooltipArrow />
                      </TooltipContent>
                    </Tooltip>

                    {activePermission?.update ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({ data: row.originData, action: "edit" })
                            }
                          >
                            <PencilIcon />
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>Edit</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}

                    {activePermission?.delete ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({
                                data: row.originData,
                                action: "delete",
                              })
                            }
                          >
                            <Trash2Icon />
                          </Button>
                        </TooltipTrigger>

                        <TooltipContent>
                          <p>Delete</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}
                  </TooltipProvider>
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
